import { Components, Theme } from "@mui/material";
import { Colors } from "style/Colors";

export const MuiChip: Components<Theme>["MuiChip"] = {
  styleOverrides: {
    outlinedSecondary: {
      color: Colors.greenLight,
      border: `1px solid ${Colors.greenLight}`,
    },
  },
};
